import { useCallback, useEffect, useState } from 'react';
import {
  BANNER_DISMISSAL_EVENT,
  dismissBannerForSession,
  getSessionDismissedBannerKeys,
  isBannerDismissedForSession,
} from 'src/utils/bannerSessionDismissals';

export const useSessionBannerDismissals = (trackDismiss, companyId = '') => {
  const normalizedCompanyId = String(companyId ?? '');
  const [dismissedKeys, setDismissedKeys] = useState(() => getSessionDismissedBannerKeys());

  useEffect(() => {
    const refresh = () => setDismissedKeys(getSessionDismissedBannerKeys());
    window.addEventListener(BANNER_DISMISSAL_EVENT, refresh);
    window.addEventListener('storage', refresh);
    return () => {
      window.removeEventListener(BANNER_DISMISSAL_EVENT, refresh);
      window.removeEventListener('storage', refresh);
    };
  }, []);

  const dismiss = useCallback(async (bannerId) => {
    dismissBannerForSession(bannerId, normalizedCompanyId);
    setDismissedKeys(getSessionDismissedBannerKeys());
    if (trackDismiss) {
      try {
        await trackDismiss({
          bannerId: String(bannerId),
          companyId: normalizedCompanyId,
        });
      } catch {
        // El cierre en sesión ya aplicó; el tracking es secundario.
      }
    }
  }, [trackDismiss, normalizedCompanyId]);

  const filterVisible = useCallback(
    (banners = []) => banners.filter(
      (banner) => !isBannerDismissedForSession(banner.id, normalizedCompanyId),
    ),
    [dismissedKeys, normalizedCompanyId],
  );

  return { dismissedKeys, dismiss, filterVisible };
};

export default useSessionBannerDismissals;
